import CRUDService from '@/services/crud'
import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: '',
  aliasNameIsAlReady: true
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error,
  getIsAliasNameAlready: state => state.aliasNameIsAlReady
}

// mutations
const mutations = {
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    const tempData = state.data
    tempData.push(model)
    Vue.set(state, 'data', tempData)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    const index = state.data.findIndex(m => m.id === model.id)
    if (index === -1) return
    const current = state.data[index]
    const updated = Object.assign({}, current, model)
    updated.endpointUrl = (model.endpoint && model.endpoint.endpoint_url) || current.endpointUrl
    updated.sourceType = model.source_selected || current.sourceType
    updated.sourceName = (model.table && model.table.name) || current.sourceName
    Vue.set(state.data, index, updated)
  },
  setActivated(state, { id, activated }) {
    const index = state.data.findIndex(item => item.id === id)
    if (index === -1) return
    Vue.set(state.data, index, Object.assign({}, state.data[index], { activated }))
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  setError(state, error) {
    state.error = error
  },
  checkCrudAliasData(state, isAliasAlready) {
    state.aliasNameIsAlReady = isAliasAlready
  }
}

const actions = {
  findAll({ commit, state }, options) {
    return CRUDService.findAll(options).then(({ result, paginate }) => {
      const data = result.map(item => {
        const endpointUrl = item.endpoint.endpoint_url
        const sourceType = item.source_selected
        const sourceName = item.table.name
        return { ...item, endpointUrl, sourceType, sourceName }
      })
      commit('setData', { data, total: paginate.total })
    })
  },
  save({ commit, state }, model) {
    delete model.endpointUrl
    delete model.sourceType
    delete model.sourceName
    commit('setError', '')
    if (!model.id) {
      return CRUDService.create(model).then((res) => {
        if (res.result) {
          commit('appendData', res.result)
          return res.result
        } else {
          const error = res && res.response && res.response.data ? res.response.data : res
          commit('setError', error)
          return Promise.reject(error)
        }
      })
    } else {
      return CRUDService.update(model).then((res) => {
        commit('updateData', res.result)
        return res.result
      })
    }
  },
  updateActivated({ commit }, model) {
    return CRUDService.update(model).then((res) => {
      const result = res && res.result
      const activated = result && typeof result.activated === 'boolean'
        ? result.activated
        : model.activated
      commit('setActivated', { id: model.id, activated })
      return result
    })
  },
  delete({ commit, state }, id) {
    return CRUDService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  },
  checkCrudAlias({ commit, state }, aliasPayload) {
    return CRUDService.checkCrudAlias(aliasPayload).then((res) => {
      commit('checkCrudAliasData', res)
      return res
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
